import React, { useCallback } from 'react';
import SunEditor from 'suneditor-react';
import { ko } from 'suneditor/src/lang';
import 'suneditor/dist/css/suneditor.min.css';
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';

const SUN_EDITOR_OPTIONS = {
  lang: ko,
  buttonList: [
    ['undo', 'redo'],
    ['bold', 'underline', 'italic', 'strike'],
    ['fontColor', 'hiliteColor', 'align', 'list'],
    ['link', 'image'],
    ['removeFormat'],
  ],
  placeholder: '팝업 내용을 입력하세요.',
  defaultStyle: "font-family: '맑은 고딕', sans-serif; font-size: 15px; line-height: 1.6;",
  minHeight: '280px',
  showPathLabel: false,
  /** 커스텀 업로드 — URL·정렬 UI는 옵션/CSS로 숨김, 크기 입력은 유지 */
  imageUrlInput: false,
  imageAlignShow: false,
  imageResizing: true,
  imageHeightShow: true,
  /** 에디터 링크 삽입 시 호스트·프로토콜 자동 붙이기 비활성 */
  linkNoPrefix: true,
  linkProtocol: null,
};

function PopBasicEditor({ value = '', onChange, onImageUpload }) {
  const handleImageUploadBefore = useCallback(
    (files, _info, uploadHandler) => {
      if (!onImageUpload || !files?.length) {
        uploadHandler({ result: [] });
        return;
      }
      (async () => {
        const file = files[0];
        const path = await onImageUpload(file);
        if (!path) {
          uploadHandler({ result: [] });
          return;
        }
        const url = `${Global.file.useUrl}files/${Commons.EncodeUrl(path)}`;
        uploadHandler({
          result: [{ url, name: file.name, size: file.size }],
        });
      })();
    },
    [onImageUpload]
  );

  return (
    <div className="pop-basic-suneditor">
      <style>
        {`
          .sun-editor-editable {
            font-family: '맑은 고딕' !important;
          }
          .sun-editor {
            border: 1px solid #ccc;
            border-radius: 8px !important;
            overflow: hidden !important;
          }
          /* 이미지 삽입 — 대체 문자열(alt) */
          .pop-basic-suneditor .se-dialog-image .se-dialog-form:has(._se_image_alt) {
            display: none !important;
          }
          /* 이미지 삽입 — 설명 넣기 */
          .pop-basic-suneditor .se-dialog-image .se-dialog-form-footer {
            display: none !important;
          }
          /* 이미지 삽입 — 정렬(기본/왼쪽/가운데/오른쪽) */
          .pop-basic-suneditor .se-dialog-image .se-dialog-footer > div:first-child,
          .pop-basic-suneditor .se-dialog-image input[name='suneditor_image_radio'],
          .pop-basic-suneditor .se-dialog-image label:has(input[name='suneditor_image_radio']) {
            display: none !important;
          }
          /* 이미지 선택 시 컨트롤 바 정렬 버튼 */
          .pop-basic-suneditor .se-controller .se-btn-group.se-btn-group-align {
            display: none !important;
          }
        `}
      </style>
      <SunEditor
        setContents={value || ''}
        onChange={onChange}
        setOptions={SUN_EDITOR_OPTIONS}
        onImageUploadBefore={onImageUpload ? handleImageUploadBefore : undefined}
      />
    </div>
  );
}

export default PopBasicEditor;
